import * as React from 'react';
import IStepsHeader from './IStepsHeader';
import * as style from './StepsHeaderStyle.module.scss'

const StepsHeader: React.SFC<IStepsHeader> = (props) => {
  const { steps, current } = props;

  return (
    <div className={style.stepsHeader}>
      {steps.map((el:string, i) => {
        return (
          <div
            className={[style.step, i + 1 === current ? style.stepActive : style.stepInactive].join(' ')}
            key={i}
          >
            {
              el.includes(' ') ?
                el.split(' ').map((innerWord: string, i) => <p key={i}>{innerWord}</p>) :
                <p>{el}</p>
            }
          </div>
        );
      })}
    </div>
  );
};

export default StepsHeader;
